import React, { useState, useEffect, useContext, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {
  CustomTextField,
  CustomTitle,
  CustomText,
  CustomButton,
} from "../../components/Custom";
import Service from "../../services";
import { useFormik } from "formik";
import validationSchema from "./validation";


const AddValidation = () => {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: '',
      description: '',
      script_name: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      saveFormData(values);
    },
  });

  async function saveFormData(values) {
    let payload = {
      name: values.name,
      description: values.description,
      script_name: values.script_name,
    };
    setErrorMsg(false);
    setLoading(true);
    try {
      const response = await Service.createValidation(payload);
      if (response.status === 200 || response.status === 201) {
        setLoading(false);
        setSubmitted(true);
      } else {
        setLoading(false);
        setErrorMsg(true);
      }
    } catch (error) {
      setLoading(false);
      setErrorMsg(true);
    }
  }

  return (
    <div className="container">
      <Grid container spacing={0}>
        <Grid item xs={12} md={12}>
          <form onSubmit={formik.handleSubmit}>
            <Box>
              <CustomTitle sx={{ fontSize: '20px', mb: 2 }}>
                Add Validation
              </CustomTitle>
              <CustomText sx={{ fontSize: '20px', mb: 2 }}>
                Please provide details of the new validation below.
              </CustomText>
              <Box
                sx={{
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: 1,
                  borderRadius: 1,
                  p: 3,
                  mb: 2,
                }}
              >
                <CustomText>Validation Name</CustomText>
                <CustomTextField
                  type="text"
                  name="name"
                  id="name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  placeholder="Enter validation name"
                  error={
                    formik.touched.name && Boolean(formik.errors.name)
                  }
                  helperText={formik.touched.name && formik.errors.name}
                  sx={{ mb: 2 }}
                  fullWidth
                />
                <CustomText>Description</CustomText>
                <CustomTextField
                  type="text"
                  name="description"
                  id="description"
                  value={formik.values.description}
                  onChange={formik.handleChange}
                  placeholder="Enter description"
                  error={
                    formik.touched.description &&
                    Boolean(formik.errors.description)
                  }
                  helperText={
                    formik.touched.description && formik.errors.description
                  }
                  sx={{ mb: 2 }}
                  fullWidth
                />
                <CustomText>Script Name</CustomText>
                <CustomTextField
                  type="text"
                  name="script_name"
                  id="script_name"
                  value={formik.values.script_name}
                  onChange={formik.handleChange}
                  placeholder="Enter script name"
                  error={
                    formik.touched.script_name &&
                    Boolean(formik.errors.script_name)
                  }
                  helperText={
                    formik.touched.script_name && formik.errors.script_name
                  }
                  sx={{ mb: 2 }}
                  fullWidth
                />
              </Box>
            </Box>
            <Box
              sx={{
                textAlign: 'center',
              }}
            >
              <CustomButton
                type="submit"
                variant="contained"
                disabled={loading}
                sx={{
                  alignItems: 'center',
                  py: 2,
                  px: 8,
                  m: 2,
                  background: '#58CC02',
                }}
              >
                {loading ? 'Submitting' : 'Add Validation'}
              </CustomButton>
            </Box>
            {submitted && (
              <p style={{ color: 'green', textAlign: 'center' }}>
                Validation added successfully
              </p>
            )}
            {errorMsg && (
              <h3 style={{ color: 'red', textAlign: 'center' }}>
                Failed to add validation
              </h3>
            )}
          </form>
        </Grid>
      </Grid>
    </div>
  );
};

export default AddValidation;
